import { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { FaFileImport, FaPlusCircle, FaSearch } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { EditableModal } from "../components/editableModal";
import ExpenseList from "../components/ExpenseList";
import { CREATE_EXPENSE_CONFIGS } from "../configs/createNovelConfig";
import AppContext from "../context/app-context";
import userProfileService from "../services/userProfileService";
import ExpenseTrackingMetadataDB from "../storage/ExpenseTrackingMetadataDB";
import { getCustomFieldsFromProfile, isValidNumber } from "../utils/helperFunctions";

export function ExpenseTrackingPage(props) {
  const { t } = useTranslation();
  const {
    userProfile,
    setLoading,
    loadItems = () => {},
    trackingItems = [],
    onlineItems = [],
    loadItemsFromOnline,
  } = useContext(AppContext);
  const [query, setQuery] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const filteredListItems = trackingItems.filter((song) => {
    return JSON.stringify(Object.values(song)).toLowerCase().includes(query.toLowerCase());
  });

  useEffect(() => {
    loadItemsFromOnline();
  }, []);

  return (
    <div style={{ padding: "1rem", maxWidth: "1200px", margin: "0 auto" }}>
      <div className="d-flex gap-3 mb-4 flex-wrap">
        <div className="d-flex gap-2 align-items-center">
          <img src="/kola2.jpg" alt={t("expenseTracking.mascotAlt")} style={{ width: "60px", height: "60px" }} />
          <h1 className="mb-0">📒 {t("expenseTracking.title")}</h1>
        </div>

        <div className="d-flex gap-2 flex-grow-1 justify-content-end">
          <Button
            as={Link}
            to="/bulk"
            variant="success"
            className="d-flex align-items-center gap-2"
            style={{
              background: "linear-gradient(135deg, #6EC3C4 0%, #FF7F7F 100%)",
              border: "none",
              borderRadius: "15px",
              padding: "0.5rem 1.5rem",
            }}
          >
            <FaFileImport />
            {t("expenseTracking.bulkAdd")}
          </Button>
          <EditableModal
            title={t("expenseTracking.createNewExpense")}
            configs={[...CREATE_EXPENSE_CONFIGS, ...getCustomFieldsFromProfile(userProfile)]}
            actionLabel={
              <span className="d-flex align-items-center gap-1">
                <FaPlusCircle /> {t("expenseTracking.create")}
              </span>
            }
            currentValue={{ currency: "USD" }}
            actionOnClick={async (data) => {
              const createdDate = new Date().toISOString();
              const { bulkAddItemStr, title, total } = data;
              if (bulkAddItemStr && bulkAddItemStr.length > 0) {
                const items = bulkAddItemStr.split("\n");
                items.forEach(async (item) => {
                  const titleAmount = item.split(",");
                  if (titleAmount.length >= 2) {
                    const tit = titleAmount[0].trim();
                    const amt = titleAmount[1].trim();
                    let description = "";
                    if (titleAmount.length >= 3) {
                      description = titleAmount[2].trim();
                    }
                    if (!tit || !amt || !isValidNumber(amt)) {
                      toast.warn(t("expenseTracking.validationError", { item: tit }));
                    } else {
                      const item = {
                        ...data,
                        title: tit,
                        total: amt,
                        description,
                        createdDate,
                        lastModifiedDate: createdDate,
                      };
                      userProfileService.putExpenseEvent({
                        updatedItem: item,
                        callback: async ({ err, data }) => {
                          if (err) {
                            toast.error(err);
                            return;
                          }
                          const { expenseResource } = data;
                          await ExpenseTrackingMetadataDB.putItemToExpenseTrackingMetadata(expenseResource);

                          toast.info(t("expenseTracking.addSuccess", { title: tit }));
                          loadItems();
                        },
                      });
                    }
                  }
                });
              } else if (title && total) {
                const item = { ...data, title, total, createdDate, lastModifiedDate: createdDate };
                delete item.bulkAddItemStr;
                userProfileService.putExpenseEvent({
                  updatedItem: item,
                  callback: async ({ err, data }) => {
                    if (err) {
                      return;
                    }
                    const { expenseResource } = data;
                    await ExpenseTrackingMetadataDB.putItemToExpenseTrackingMetadata(expenseResource);
                    toast.info(t("expenseTracking.addSuccess", { title }));
                    loadItems();
                  },
                });
              }
            }}
            buttonStyle={{
              background: "linear-gradient(135deg, #6EC3C4 0%, #FF7F7F 100%)",
              border: "none",
              borderRadius: "15px",
              padding: "0.5rem 1.5rem",
            }}
          />
        </div>
      </div>

      <div className="mb-4">
        <div className="position-relative">
          <Form.Control
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("expenseTracking.filterExpenses")}
            style={{
              borderRadius: "20px",
              paddingLeft: "40px",
              border: "2px solid #6EC3C4",
            }}
          />
          <FaSearch
            className="position-absolute"
            style={{ left: "15px", top: "50%", transform: "translateY(-50%)", color: "#6EC3C4" }}
          />
        </div>
      </div>
      <div className="rounded-3 shadow-sm" style={{ backgroundColor: "white", padding: "1rem" }}>
        <h3>{t("expenseTracking.allExpenses")}</h3>
        <ExpenseList items={filteredListItems} paginationSize={50} loadItems={loadItems} onlineItems={onlineItems} />
      </div>
    </div>
  );
}
